/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '.';
import { merge } from '../helper';

import type { Result, Headers, Method } from '../type';

type Category = {
    file: number;
    category: number;
};

type Options = {
    method: Method;
    body: {
        categories: Category[];
        entity: string;
        files: File[];
        namespace: string;
    };
    security: {
        key: string;
        secret: string;
    };
    headers?: Headers;
    result?: Result;
};

export default function file<T>(url: string, options: Options) {
    const body = new FormData();
    body.append('entity', options.body.entity);
    body.append('namespace', options.body.namespace);

    if (Array.isArray(options.body.files)) {
        options.body.files.forEach((file) => {
            body.append('files[]', file);
        });
    }

    if (Array.isArray(options.body.categories)) {
        options.body.categories.forEach((categories) => {
            body.append('categories[]', JSON.stringify(categories));
        });
    }

    // prettier-ignore
    const headers = merge({
        MantumKey: options?.security?.key,
        MantumSecret: options?.security?.secret
    }, options.headers);

    return request<T>(url, {
        body: body,
        headers: headers,
        method: options.method,
        result: options?.result
    });
}
